import React, { useEffect, useState } from 'react';
import PageContentWrapper from '../../pages/components/pageContentWrapper';
import TripAlertBrandingContainer from './TripAlertBrandingContainer';
import { getBrandingImage } from '../../service/brandingImageService';

const AccountSettingsContainer: React.FC = () => {
  const [brandingImageUrl, setBrandingImageUrl] = useState<string>('');
  const [isCurrentImageLoading, setIsCurrentImageLoading] = useState<boolean>(
    true,
  );
  const [hasErrorGettingImages, setHasErrorGettingImages] = useState<boolean>(
    false,
  );

  const fetchBrandingImageUrl = async () => {
    try {
      setIsCurrentImageLoading(true);
      const response: any = await getBrandingImage();
      setBrandingImageUrl(response.brandingImageUrl);
    } catch (error) {
      setHasErrorGettingImages(true);
    } finally {
      setIsCurrentImageLoading(false);
    }
  };

  useEffect(() => {
    fetchBrandingImageUrl();
  }, []);
  return (
    <PageContentWrapper title="TRIP ALERT BRANDING">
      <TripAlertBrandingContainer
        hasErrorGettingImages={hasErrorGettingImages}
        isCurrentImageLoading={isCurrentImageLoading}
        brandingImageUrl={brandingImageUrl}
        fetchBrandingImageUrl={fetchBrandingImageUrl}
      />
    </PageContentWrapper>
  );
};

export default AccountSettingsContainer;
